import $ from 'jquery'
import 'slick-carousel/slick/slick.min.js'
import objectFitImages from 'object-fit-images'

export const jqueryProcess = () => {
	objectFitImages()

  	// .l-header fixed /////////////////////////////////////////////
	var $header = $('.l-header');
	$(window).on('load scroll', function() {
		var value = $(this).scrollTop();
		if ( value > 200 ) {
			$header.addClass('fixed');
		} else {
			$header.removeClass('fixed');
		}
	});
	// .header-toggle click ///////////////////////////////////////
	$('.header-toggle').click(function(){
		$('.header-wrap').toggleClass('open');
	});
	var width = $(window).width();
	if(width <= 960){
		$('.header-nav-link').click(function(){
			$('.header-wrap').toggleClass('open');
		});
	}
	// .numbers_viewmore ///////////////////////////////////////
	$('.numbers_viewmore_btn').click(function(){
		$('.numbers_viewmore_content').toggleClass('open');
	});
	// .scroll /////////////////////////////////////////////
	var scrollElm = (function() {
		if('scrollingElement' in document) {
		return document.scrollingElement;
		}
		if(navigator.userAgent.indexOf('WebKit') != -1) {
		return document.body;
		}
		return document.documentElement;
	})();
	$('a[href^="#"]').not('.noscroll').on('click', function() {
		var speed = 1000;
		var easing = 'swing';
		var href= $(this).attr("href");
		var headerHight = 60;
		$(scrollElm).animate({
		scrollTop: $(href == "#" ? 'html' : href).offset().top-headerHight
		}, speed, easing);
		return false;
	});
	// slick ///////////////////////////////////////////////////////////////
	$('.visual_image_first').slick({
		autoplay: true,
		speed: 1000,
		arrows: false,
		infinite: true,
		draggable: false,
		pauseOnFocus: false,
		swipe: false,
		pauseOnHover: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplaySpeed: 8000
	});
	$('.visual_image_second').slick({
		autoplay: true,
		speed: 1000,
		arrows: false,
		infinite: true,
		draggable: false,
		pauseOnFocus: false,
		swipe: false,
		pauseOnHover: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplaySpeed: 8000
	});
	$('.visual_image_third').slick({
		autoplay: true,
		speed: 1000,
		arrows: false,
		infinite: true,
		draggable: false,
		pauseOnFocus: false,
		swipe: false,
		pauseOnHover: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplaySpeed: 8000
	});
	$('.interview_slick').slick({
		speed: 1000,
		slideToShow: 3,
		slideToScroll: 1,
		variableWidth: true,
		centerMode: true,
		prevArrow:'<div class="slick-prev"></div>',
		nextArrow:'<div class="slick-next"></div>',
		responsive: [{
			breakpoint: 990,
			settings: {
				arrows: false,
				slideToShow: 1,
				centerPadding: '60px'
			}
		}]
	});  

	// scroll to top
	let topscroll = document.querySelector('.topscroll')
	document.addEventListener('scroll', () => {
		let flowEl = document.querySelector('#careerpaths')
		let recruitmentsEl = document.querySelector('#recruitments')

		if (window.scrollY >= (flowEl.offsetTop - flowEl.offsetHeight)) {
			topscroll.style.opacity = 1
			topscroll.style.bottom = '25px'
			if (window.scrollY >= (recruitmentsEl.offsetTop - recruitmentsEl.offsetHeight)) {
				topscroll.querySelector('svg').style.fill = 'white'
			} else {
				topscroll.querySelector('svg').style.fill = '#111'
			}
		} else {
			topscroll.style.opacity = 0
			topscroll.style.bottom = '-20px'
		}
	}, false)
}


// WEBPACK FOOTER //
// ./src/externals/common.js